var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input-field",attrs:{"placeholder":_vm.placeholder,"name":_vm.name,"type":_vm.type,"step":_vm.step},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }